export default __webpack_public_path__ + "static/media/dashbaord_eye_off.016aedb4.svg";